import { authorizedRequest } from '../index';

export const initializePaymentAction = (payload: { statementId: number }) => {
  return authorizedRequest().post(`/payment/`, payload);
};
